import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export function AuthProvider({ children }) {
    return _jsx(_Fragment, { children: children });
}
